import { ArrowsOut } from '@phosphor-icons/react';

export default ArrowsOut;
